import { render, staticRenderFns } from "./AdminHoursBookedBySpecialist.vue?vue&type=template&id=15ec876e"
import script from "./AdminHoursBookedBySpecialist.vue?vue&type=script&lang=js"
export * from "./AdminHoursBookedBySpecialist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports